import React, { PropsWithChildren } from 'react';
import { DeviceCodeAuthorizationModal } from './DeviceCodeAuthorizationModal';

export const DeviceCodeAuthorizationModalProvider: React.FC<
    PropsWithChildren
> = ({ children }) => {
    return (
        <>
            <DeviceCodeAuthorizationModal />
            {children}
        </>
    );
};
